import { z } from 'zod';

import { PaginationQuerySchema } from '../pagination';

export const PixabaySearchSchema = PaginationQuerySchema.extend({
  query: z.string().min(1, 'Query cannot be empty'),
});

export type IPixabaySearchDto = z.infer<typeof PixabaySearchSchema>;
